import request from '@/api/request.js'

// 新增
export function ProductDetailInsert(data) {
    return request({
        url: '/api/product/productdetailinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function ProductDetailDelete(id) {
    return request({
        url: `/api/product/productdetaildelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function ProductDetailUpdate(id, data) {
    return request({
        url: `/api/product/productdetailupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function ProductDetailGetById(id) {
    return request({
        url: `/api/product/getproductdetailbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function ProductDetailGetList(params) {
    return request({
        url: '/api/product/getproductdetaillist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function ProductDetailGetPageList(params) {
    return request({
        url: '/api/product/getproductdetailpagelist',
        method: 'get',
        params: params
    })
}